import { CaseResourceType } from '@/api/apis/case';
import { RoutePlanResources } from '@/types/route';
import { RouteResource } from './RouteResource';

type RouteResourcesListProps = {
  suggestedRouteId: string;
  resources: Partial<RoutePlanResources>;
  orTimeUTC: string;
};

const DISPLAYED_RESOURCE_TYPES = [
  CaseResourceType.ClinicalSpecialist,
  CaseResourceType.OCSConsole,
  CaseResourceType.Surgeon,
] as const;

export const RouteResourcesList = ({ suggestedRouteId, resources, orTimeUTC }: RouteResourcesListProps) => {
  return (
    <div className="flex gap-2 justify-end grow items-stretch">
      {DISPLAYED_RESOURCE_TYPES.map((resourceType) => {
        const resource = resources[resourceType];

        if (!resource) return null;

        return (
          <RouteResource
            key={resourceType}
            suggestedRouteId={suggestedRouteId}
            resource={resource}
            orTimeUTC={orTimeUTC}
          />
        );
      })}
    </div>
  );
};
